import DoAPICall from './DoAPICall'

//Create mno
    export async function createMNO(userToken, mno){
            const apiPayload = {
                httpMethod:'post',
                userToken,
                uri:'mnos',
                payLoad:{
                    name:mno.name,
                    smsHandler:mno.smsHandler,
                    colour:mno.colour,
                    contactName:mno.contactName,
                    contactEmail:mno.contactEmail,
                    contactNo:mno.contactNo,
                    logo:mno.logo,                   
                },
                requestOptions:{}
            }
            return await DoAPICall(apiPayload)
        }

//Get All mno
    export async function getMNOs(userToken){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'mnos',
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get One mno
    export async function getMNO(userToken, id){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'mnos/'+id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Update mno
    export async function updateMNO(userToken, mno){
        const apiPayload = {
            httpMethod:'put',
            userToken,
            uri:'mnos/'+mno.id,
            payLoad:{
                name:mno.name,
                smsHandler:mno.smsHandler,
                colour:mno.colour,
                contactName:mno.contactName,
                contactEmail:mno.contactEmail,
                contactNo:mno.contactNo,
                logo:mno.logo
            },
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Delete mno
    export async function deleteMNO(userToken, id){
        const apiPayload = {
            httpMethod:'delete',
            userToken,
            uri:'mnos/'+id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }